import { Hidden, Tooltip } from '@material-ui/core';
import {
  CheckInIcon,
  EditIconTwoTone,
  InformationIcon,
  ProjectsIcon,
  ResumeIcon,
} from '@room-match/shared-ui-components';
import { Heading } from 'components/Audition/Audtion.styles';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'shared/constants/ROUTES';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { useUser } from 'shared/hooks';
import { useSetHeaderBack, useSetHeaderTitle } from 'shared/hooks/useSetHeader';
import { useAppSelector } from 'shared/redux/store';
import { formattedStaticDateEnd } from 'shared/utils';
import { authToken } from 'shared/utils/authToken';
import { ls } from 'shared/utils/ls';
import { AuditionRequests } from './AuditionRequests';
import {
  ActionButton,
  ActionButtonTwoRowLabel,
  FlexContainer,
  GuardianHeading,
  MainCont,
  ManageButton,
  MeCont,
  PlanCont,
  PlanText,
  WelcomeCont,
  WelcomeHeading,
} from './Dashboard.styles';
import { DashboardMobile } from './DashboardMobile';
import Guardianship from './Guardianship/Guardianship';
import NewImage from './NewImage';
import { Profile } from './Profile';
import { SubmittedSelfTapes } from './SubmittedSelfTapes';
import { UpcomingAuditions } from './UpcomingAuditions';

const Dashboard = () => {
  const { getAuthToken } = authToken();
  const { isUserTypeGuardian } = useUser();
  const { getLS } = ls();
  const { role_id, project_id } = JSON.parse(getLS('pending_job_application') || '{}');
  const { app: appState, user: userState } = useAppSelector((state) => state);
  const { guardianUI, isGuardian } = appState.guardian;
  const history = useHistory();
  const talentName = guardianUI
    ? `${userState?.user?.attributes.first_name} `
    : userState?.user?.attributes.stage_first_name || userState?.user?.attributes.first_name;
  const shouldNotBeHidden = !getLS('guardian_token') || isUserTypeGuardian;

  useSetHeaderBack(false);
  useSetHeaderTitle(`Dashboard`);

  useEffect(() => {
    if (role_id && project_id && Boolean(getAuthToken())) {
      history.push(`${ROUTES.TALENT.OPPORTUNITIES}/${project_id}/${role_id}`);
    }
  }, [role_id, project_id]);

  return (
    <>
      {guardianUI ? <React.Fragment /> : <Guardianship />}
      <Hidden smUp>
        <DashboardMobile data={userState?.user} />
      </Hidden>
      <Hidden xsDown>
        <MainCont>
          <MeCont>
            <NewImage src={userState?.user?.attributes.picture} data={userState?.user} />
            <WelcomeCont>
              <WelcomeHeading style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: '10px' }}>Welcome {talentName}</span>
                <a href="/talent/settings/general_information">
                  <EditIconTwoTone style={{ fontSize: '18px' }} />
                </a>
              </WelcomeHeading>
              {isGuardian ? (
                <GuardianHeading style={{ fontStyle: 'italic' }}>(Guardian)</GuardianHeading>
              ) : (
                <React.Fragment />
              )}
            </WelcomeCont>
            <PlanCont style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
              {shouldNotBeHidden ? (
                <>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {/* <img src={'/plans/special-6-month.svg'} style={{ width: 40, height: 40, alignSelf: 'center' }} /> */}
                    <PlanText>
                      <CustomTypography fontSize={20} fontWeight={500}>
                        Active Plan: Special Unlimited Media Intro Offer
                      </CustomTypography>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <CustomTypography style={{ marginRight: '5px', fontWeight: 400, fontSize: 12 }}>
                          until {formattedStaticDateEnd}
                        </CustomTypography>
                        <Tooltip
                          title={
                            <div style={{ textAlign: 'justify' }}>
                              <span style={{ fontSize: 11 }}>
                                Upload all your images, video, and audio files now. Add media to your skills and resume
                                credit clips too. ALL media added before {formattedStaticDateEnd} will be Grandfathered
                                in (maintained) for the life of your profile, regardless if you are on a FREE or PREMIUM
                                package.
                              </span>
                              <br />
                              <span style={{ fontSize: 11 }}>
                                Our ZERO risk offer to encourage you to put your best foot forward to casting directors.
                              </span>
                            </div>
                          }
                        >
                          <span style={{ display: 'flex' }}>
                            <InformationIcon style={{ cursor: 'pointer', fontSize: '16px' }} />
                          </span>
                        </Tooltip>
                      </div>
                    </PlanText>
                  </div>
                  <ManageButton onClick={() => history.push(`${ROUTES.TALENT.SETTINGS}/plans`)}>
                    Manage My Plan
                  </ManageButton>
                </>
              ) : null}
            </PlanCont>
          </MeCont>
          {guardianUI ? (
            <React.Fragment />
          ) : (
            <React.Fragment>
              <FlexContainer>
                <AuditionRequests count={userState?.user?.attributes.audition_requests_count || 0} />
                <UpcomingAuditions count={userState?.user?.attributes.upcoming_auditions_count || 0} />
              </FlexContainer>
              <FlexContainer>
                <SubmittedSelfTapes count={userState?.user?.attributes.self_tapes_count || 0} />
                <Profile />
              </FlexContainer>
              <FlexContainer>
                <ActionButton onClick={() => history.push(`${ROUTES.TALENT.CHECKIN}`)} startIcon={<CheckInIcon />}>
                  Check-In
                </ActionButton>
                <ActionButton
                  onClick={() => history.push(`${ROUTES.TALENT.MEDIA}/dashboard`)}
                  startIcon={<ProjectsIcon />}
                >
                  <ActionButtonTwoRowLabel>
                    <CustomTypography fontSize={18} fontWeight={500}>
                      Manage My Media
                    </CustomTypography>
                    <CustomTypography fontSize={12}>Upload images, videos etc…</CustomTypography>
                  </ActionButtonTwoRowLabel>
                </ActionButton>
                <ActionButton
                  onClick={() => history.push(`${ROUTES.TALENT.MYINFO}/general_appearance`)}
                  startIcon={<ResumeIcon />}
                >
                  <ActionButtonTwoRowLabel>
                    <CustomTypography fontSize={18} fontWeight={500}>
                      Edit Resume/ Skills / Sizes/ Social
                    </CustomTypography>
                    <CustomTypography fontSize={12}>
                      Add your experience, skills, sizes and social reach
                    </CustomTypography>
                  </ActionButtonTwoRowLabel>
                </ActionButton>
              </FlexContainer>
            </React.Fragment>
          )}
        </MainCont>
      </Hidden>
      {guardianUI ? (
        <React.Fragment>
          <Heading>
            <p style={{ fontSize: 16 }}>Please select a Family member profile below to proceed</p>
          </Heading>
          <Guardianship />
        </React.Fragment>
      ) : (
        <></>
      )}
    </>
  );
};

export default Dashboard;
